import type { WorkflowContext, WorkflowStepModule } from "../types";

export type ApprovalGateSnapshot = null;
export const APPROVAL_GATE_STATES: readonly string[] = ["in_review", "approved", "scheduled", "published"];

function approvalHref(context: WorkflowContext): string {
  if (context.brief.state === "published") {
    return `/outputs?brandId=${encodeURIComponent(context.brandId)}`;
  }
  return `/review?brandId=${encodeURIComponent(context.brandId)}`;
}

function approvalLabel(context: WorkflowContext): string {
  return context.brief.state === "published" ? "Open outputs" : "Open review";
}

export const approvalGateStep: WorkflowStepModule<ApprovalGateSnapshot> = {
  id: "approval_gate",
  label: "Approval gate",
  renderer: "approval",
  isEligible: (context: WorkflowContext) =>
    APPROVAL_GATE_STATES.includes(context.brief.state)
      ? { eligible: true }
      : { eligible: false, reason: "Available after voice review passes." },
  callToAction: (context: WorkflowContext) => ({
    label: approvalLabel(context),
    href: approvalHref(context),
  }),
  extractSnapshot: () => null,
};
